const COLORS = ['#f472b6', '#facc15', '#60a5fa', '#4ade80', '#c084fc', '#fb923c', '#38bdf8', '#f43f5e'];
const MAX_FRAMES = 600;

function prefersReducedMotion() {
  return typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function originPoint(origin) {
  if (origin && typeof origin.getBoundingClientRect === 'function') {
    const rect = origin.getBoundingClientRect();
    if (rect.width || rect.height || rect.left || rect.top) {
      return {
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2,
      };
    }
  }
  if (origin && typeof origin.clientX === 'number') {
    return { x: origin.clientX, y: origin.clientY };
  }
  if (origin && typeof origin.x === 'number' && typeof origin.y === 'number') {
    return { x: origin.x, y: origin.y };
  }
  return {
    x: window.innerWidth / 2,
    y: Math.min(window.innerHeight / 3, 220),
  };
}

function makePiece({ x, y, angle, spread, speed, lift, gravity, decay, colors, delay }) {
  const direction = ((angle - spread / 2) + Math.random() * spread) * (Math.PI / 180);
  const velocity = speed * (0.6 + Math.random() * 0.4);

  return {
    x,
    y,
    vx: Math.cos(direction) * velocity,
    vy: Math.sin(direction) * velocity - lift,
    w: 4 + Math.random() * 5,
    h: 6 + Math.random() * 8,
    rotation: Math.random() * 360,
    vr: (Math.random() - 0.5) * 18,
    color: colors[Math.floor(Math.random() * colors.length)],
    life: 1,
    decay: decay * (0.8 + Math.random() * 0.4),
    gravity: gravity * (0.85 + Math.random() * 0.3),
    drag: 0.985,
    delay,
  };
}

function spawnCannon(cannon, colors) {
  const { count = 64, angle = 0, spread = 360, speed = 10, lift = 3.2, gravity = 0.2, decay = 0.017, delay = 0 } = cannon;
  const perPiece = (value, index) => (typeof value === 'function' ? value(index, count) : value);
  const pieces = [];

  for (let i = 0; i < count; i += 1) {
    pieces.push(makePiece({
      x: perPiece(cannon.x, i),
      y: perPiece(cannon.y, i),
      angle,
      spread,
      speed,
      lift,
      gravity,
      decay,
      colors,
      delay: perPiece(delay, i),
    }));
  }

  return pieces;
}

function launch(cannons, colors = COLORS) {
  if (typeof document === 'undefined' || prefersReducedMotion()) {
    return;
  }

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return;
  }

  const dpr = Math.max(1, window.devicePixelRatio || 1);
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText = [
    'position:fixed',
    'inset:0',
    'width:100%',
    'height:100%',
    'pointer-events:none',
    'z-index:2147483646',
  ].join(';');
  document.body.appendChild(canvas);

  canvas.width = Math.floor(window.innerWidth * dpr);
  canvas.height = Math.floor(window.innerHeight * dpr);
  canvas.style.width = `${window.innerWidth}px`;
  canvas.style.height = `${window.innerHeight}px`;
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

  const particles = cannons.reduce((all, cannon) => all.concat(spawnCannon(cannon, colors)), []);

  let frame = 0;
  const tick = () => {
    frame += 1;
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    let alive = 0;
    particles.forEach((particle) => {
      if (particle.delay > frame) {
        alive += 1;
        return;
      }
      particle.vx *= particle.drag;
      particle.vy = particle.vy * particle.drag + particle.gravity;
      particle.x += particle.vx;
      particle.y += particle.vy;
      particle.rotation += particle.vr;
      particle.life -= particle.decay;
      if (particle.life <= 0) {
        return;
      }
      alive += 1;
      ctx.save();
      ctx.translate(particle.x, particle.y);
      ctx.rotate((particle.rotation * Math.PI) / 180);
      ctx.globalAlpha = Math.max(0, particle.life);
      ctx.fillStyle = particle.color;
      ctx.fillRect(-particle.w / 2, -particle.h / 2, particle.w, particle.h);
      ctx.restore();
    });

    if (alive > 0 && frame < MAX_FRAMES) {
      window.requestAnimationFrame(tick);
      return;
    }
    if (canvas.parentNode) {
      canvas.parentNode.removeChild(canvas);
    }
  };

  window.requestAnimationFrame(tick);
}

export function burstConfetti(origin) {
  const point = originPoint(origin);

  launch([{ x: point.x, y: point.y, count: 64, spread: 360, speed: 13, gravity: 0.2, decay: 0.017 }]);
}

export function celebrationConfetti() {
  const width = window.innerWidth;
  const height = window.innerHeight;
  const sideCannon = (x, angle) => ({
    x,
    y: height * 0.62,
    angle,
    spread: 60,
    speed: 26,
    lift: 6,
    count: 80,
    gravity: 0.24,
    decay: 0.008,
  });

  launch([
    sideCannon(width * 0.04, -55),
    sideCannon(width * 0.96, -125),
    {
      x: () => Math.random() * width,
      y: -40,
      angle: 90,
      spread: 40,
      speed: 4,
      lift: 0,
      count: 140,
      gravity: 0.12,
      decay: 0.005,
      delay: () => Math.floor(Math.random() * 120),
    },
  ]);
}
